<template>
  <nav class="
      navbar navbar-main navbar-expand-lg
      px-0
      mx-4
      shadow-none
      border-radius-xl
    " v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" id="navbar">
        <div class="pe-md-3 d-flex align-items-center ms-md-auto">
          <div class="input-group">
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center pe-2" v-if="!shouldHideIcon">
            <a href="#" class="p-0 nav-link text-white" :class="[showMenu ? 'show' : '']" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu">
              <i class="fa fa-user me-sm-2"></i>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton">
              <li class="mb-2">
                <a class="dropdown-item border-radius-md" @click="logout">
                  <div class="py-1 d-flex">
                    <div class="my-auto">
                      <img src="../../../public/favicon.png" class="avatar avatar-sm me-3" alt="logo" />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">Moto Boutique</span>-Sesión activa
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-user me-1"></i>
                        Cerrar sesión
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapMutations, mapActions } from "vuex";

export default {

  name: "navbar",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),
    ...mapActions('auth', ["logoutUser"]),
    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    logout() {
      this.$swal.fire({
        title: "Cerrar sesión",
        text: "Deseas cerrar la sesión actual?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Cerrar sesión",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
          cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
        },
        buttonsStyling: false,  // Desactivar el estilo predeterminado
      }).then((result) => {
        if (result.isConfirmed) {
          this.logoutUser()
            .then(() => {
              // console.log("LOGOUT RESPONSE ",response)
              this.$router.replace({ path: '/signin'})
            }
            )
            .catch((error) => {
              console.log("ERROR SALIR SESION ", error)
              this.$swal.fire({
                icon: "error",
                title: "No se pudo cerrar la sesión de forma correcta.",
                text: "Por favor intentalo nuevamente"
              })
            }
            )
        }
      });
    }
  },
  computed: {
    shouldHideIcon() {
      // Retorna true si el nombre de la ruta actual es 'Scanner', ocultando el ícono
      return this.$route.name === 'Scanner';
    }
  }
};
</script>
